export const GROUP = 'groupRegistration';
export const ONLINE = 'onlineRegistration';
